/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
/* global gettext */
import { separateByRightmost, reverse } from 'utils';

/**
 * @see {@link https://github.com/django/django/blob/stable/1.11.x/django/core/validators.py#L174}
 */
export const userRegex = /^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*$/i;

/**
 * @see {@link https://github.com/django/django/blob/stable/1.11.x/django/core/validators.py#L179}
 */
export const domainRegex = /^((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+)(?:[A-Z0-9-]{2,63})$/i;

/**
 * @see {@link https://github.com/django/django/blob/stable/1.11.x/django/core/validators.py#L183}
 */
export const literalRegex = /^\[([A-f0-9:.]+)\]$/i;

/**
 * @see {@link https://github.com/django/django/blob/stable/1.11.x/django/core/validators.py#L195}
 * @param {string} value
 * @returns {string}
 */
export const email = (value) => {
  if (!value) {
    return undefined;
  }
  const msg = 'Invalid email address.';
  if (!value.includes('@')) {
    return gettext(msg);
  }
  const [userPart, domainPart] = separateByRightmost('@', value);
  if (!userPart || !domainPart) {
    return gettext(msg);
  }
  if (!userRegex.test(userPart)) {
    return gettext(msg);
  }
  if (domainPart === 'localhost' || domainPart === 'fc-local.com') {
    return undefined;
  }
  if (reverse(domainPart)[0] === '-') {
    return gettext(msg);
  }
  if (!domainRegex.test(domainPart)) {
    if (!literalRegex.test(domainPart)) {
      return gettext(msg);
    }
  }
  return undefined;
};

export const strongPassword = value => (
  value && (
    value.length < 8
    || !/[A-Z]/.test(value)
    || !/[a-z]/.test(value)
    || !/[0-9]/.test(value)
    || !/[-!$%^&*()_+|~=@#`{}\[\]:";'<>?,.\\\/]/.test(value) // eslint-disable-line no-useless-escape
  )
    ? gettext('Passwords must contain at least 8 characters; at least one upper case, one lower case, one digit and one special character.') // eslint-disable-line max-len
    : undefined
);

export default 'default';
